export function Copyright(props: { text?: string | null }) {
  if (!props.text) return null;

  return (
    <div className="absolute right-4 bottom-4 bg-black/60 px-2 py-1 text-[10px]/[130%] font-medium whitespace-nowrap text-white">
      &copy; {props.text}
    </div>
  );
}
